export default [
  {
    path: '/vendors',
    name: 'vendors',
    component: () => import('@/views/vendors/VendorShow.vue'),
    meta: {
      requiresAuth: true,
      title: 'Vendor Management',
      roles: ['sponsor']
    }
  },
  {
    path: '/vendors/create',
    name: 'vendors.create',
    component: () => import('@/views/vendors/VendorCreate.vue'),
    meta: {
      requiresAuth: true,
      title: 'Add Vendor',
      roles: ['sponsor']
    }
  },
  {
    path: '/vendors/:id',
    name: 'vendors.show',
    component: () => import('@/views/vendors/VendorShow.vue'),
    meta: {
      requiresAuth: true,
      title: 'Vendor Details',
      roles: ['sponsor']
    }
  },
  {
    path: '/vendors/:id/edit',
    name: 'vendors.edit',
    component: () => import('@/views/vendors/VendorEdit.vue'),
    meta: {
      requiresAuth: true,
      title: 'Edit Vendor',
      roles: ['sponsor']
    }
  },
  // Vendor Link Request Routes
  {
    path: '/vendors/:vendorId/link-requests',
    name: 'vendor-link-requests.index',
    component: () => import('@/views/vendors/VendorLinkRequestsIndex.vue'),
    meta: {
      requiresAuth: true,
      title: 'Vendor Link Requests',
      roles: ['sponsor']
    }
  },
  {
    path: '/vendors/:vendorId/link-requests/create',
    name: 'vendor-link-requests.create',
    component: () => import('@/views/vendors/VendorLinkRequestCreate.vue'),
    meta: {
      requiresAuth: true,
      title: 'Request Vendor Link',
      roles: ['sponsor']
    }
  },
  {
    path: '/vendor-link-requests/:id',
    name: 'vendor-link-requests.show',
    component: () => import('@/views/vendors/VendorLinkRequestShow.vue'),
    meta: {
      requiresAuth: true,
      title: 'Link Request Details',
      roles: ['sponsor']
    }
  }
]
